"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isNil_1 = __importDefault(require("lodash/isNil"));
const getFieldValidator_1 = __importDefault(require("./getFieldValidator"));
const fieldTypes_1 = __importDefault(require("../../fieldTypes"));
const Errors_1 = __importDefault(require("../../Errors"));
async function getValidationErrors(params) {
    const { schema, doc, currentDoc, value, currentSchema, keys, options = {}, args = [] } = params;
    const info = { schema, doc, currentDoc, keys, currentSchema, options };
    if ((0, isNil_1.default)(value)) {
        if (!currentSchema.optional && !options.omitRequired) {
            return Errors_1.default.REQUIRED;
        }
    }
    else {
        const validatorKey = (0, getFieldValidator_1.default)(currentSchema.type);
        const validator = validatorKey === 'custom' ? currentSchema.type : fieldTypes_1.default[validatorKey];
        const error = await validator.validate(value, info, ...args);
        if (error) {
            return error;
        }
    }
    // to not deprecate yet custom field
    if (currentSchema.custom)
        currentSchema.validate = currentSchema.custom;
    if (currentSchema.validate) {
        const customError = await currentSchema.validate(value, info, ...args);
        if (customError) {
            return customError;
        }
    }
    const type = currentSchema.type;
    if (type.__validate) {
        const typeError = await type.__validate(value, info, ...args);
        if (typeError) {
            return typeError;
        }
    }
    return null;
}
exports.default = getValidationErrors;
